module.exports = __webpack_public_path__ + "static/media/silver-giggle.a68ddfe6.jpg";